export default __webpack_public_path__ + "static/media/gorilla2.68b647e2.png";